import { Component, inject, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DSM34Dialog } from '@eredes/dsm34';

import { GlobalService } from '../../_core/services/global.service';
import { PwdService } from '../../_core/services/pwd.service';
import { EdpValidators } from '../../_shared/edp-validators/edp-validators';
import { GenericModalComponent } from '../../_shared/generic-modal/generic-modal.component';
import { ValidationRulesModalComponent } from '../../auth/validation-rules-modal/validation-rules-modal.component';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-user-verify',
  templateUrl: './user-verify.component.html',
  standalone: false,
})
export class UserVerifyComponent implements OnInit {
  resetForm: UntypedFormGroup;
  modalDataRequest: any;
  invalidPwd = false;
  barArray: any[];
  pwdLabel = '';
  pwdType = 'password';
  pwdTypeConfirm = 'password';
  userAccount: string;
  validation = '';
  data: any;
  userNif: any;
  userEmail: any;
  id = '';
  token = '';

  get f(): FormGroup['controls'] {
    return this.resetForm.controls;
  }

  protected readonly route = inject(ActivatedRoute);
  protected readonly router = inject(Router);
  protected readonly authService = inject(AuthService);
  protected readonly fb = inject(UntypedFormBuilder);
  protected readonly pwdService = inject(PwdService);
  protected readonly dialog = inject(DSM34Dialog);
  protected readonly globalService = inject(GlobalService);

  private readonly validatorPattern =
    /^(?!.*([A-Za-z0-9$#%@&=.+*()[\]{}:;\\<,\'.:\/_-])\1{2}).*(?=.{10,})(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\d])(?=.*[$#%@&=.+*()[\]{}:;\\<,\'.:\/_-]).*$/;

  ngOnInit(): void {
    this.globalService.clearStorage();

    this.resetPassForm();
    this.barArray = this.pwdService.setBarColors(4, '#DDD', []);
    this.setIdToken();
  }

  openRules(): void {
    this.dialog.open(ValidationRulesModalComponent, {
      disableClose: false,
    });
  }

  resetPassForm(data?): void {
    this.resetForm = this.fb.group(
      {
        pwd: ['', [EdpValidators.required, EdpValidators.minLength(10), EdpValidators.pattern(this.validatorPattern)]],
        confirmPwd: [
          '',
          [EdpValidators.required, EdpValidators.minLength(10), EdpValidators.pattern(this.validatorPattern)],
        ],
      },
      {
        validator: EdpValidators.MatchPassword,
      }
    );
  }

  checkPwd(e: any): void {
    const pwdStrength = this.pwdService.onChangePwd(e.target.value);
    this.pwdLabel = pwdStrength.label;
    this.barArray = pwdStrength.barArray;
    this.invalidPwd = pwdStrength.invalid ? true : false;
  }

  togglePwd(): void {
    this.pwdType === 'password' ? (this.pwdType = 'text') : (this.pwdType = 'password');
  }

  togglePwdConfirm(): void {
    this.pwdTypeConfirm === 'password' ? (this.pwdTypeConfirm = 'text') : (this.pwdTypeConfirm = 'password');
  }

  onSetPassword(): void {
    this.authService.setPassword(this.id, this.token, this.resetForm.controls.pwd.value).subscribe(
      (result) => {
        this.getSuccessModal();
      },
      (err) => {
        console.error(err);
        this.getErrorModal();
      }
    );
  }

  protected setIdToken(): void {
    const url = this.route.snapshot.url;
    if (url.length === 3) {
      this.id = url[1].path;
      this.token = url[2].path;
    }
  }

  protected getSuccessModal(): void {
    const confirmDialog = this.dialog.open(GenericModalComponent, {
      data: {
        modalTitle: 'Definição de Password',
        list: [
          { value: 'A sua password foi definida com sucesso!' },
          { value: 'Por favor, aguarde uns minutos para efetuar o login.' },
          { value: 'Obrigado.' },
        ],
        btnConfirmText: 'OK',
        hasList: true,
        success: true,
      },
      disableClose: true,
    });
    confirmDialog.afterClosed().subscribe((result) => {
      this.router.navigate(['login']);
    });
  }

  protected getErrorModal(): void {
    const confirmDialog = this.dialog.open(GenericModalComponent, {
      data: {
        modalTitle: 'Erro na definição de Password',
        modalText: 'Ocorreu um erro. Por favor, tente mais tarde.',
        btnConfirmText: 'OK',
        error: true,
      },
      disableClose: true,
    });
    confirmDialog.afterClosed().subscribe((result) => {});
  }
}
